// 붙여넣기 정제 — 백엔드가 저장/발송 시 살균하지 않으므로(render-preview 만 bleach),
// 프론트가 유일한 방어선이다. 붙여넣은 HTML 을 이메일에 안전한 좁은 화이트리스트로 자른다.
// DOMPurify 인스턴스는 주입받는다(브라우저는 window, 테스트는 jsdom window 로 생성).
// node:test + webpack 양쪽 사용을 위해 CommonJS.

// 이메일에서 대체로 안전한 태그만 허용(레이아웃 table + 인라인 서식).
const ALLOWED_TAGS = [
    'table', 'tr', 'td', 'tbody', 'thead',
    'a', 'img', 'strong', 'b', 'em', 'i', 'u', 'span', 'br', 'p', 'div',
    'ul', 'ol', 'li', 'hr', 'font',
]
// class 는 전역 금지(프레임 class 오염 방지) → ALLOWED_ATTR 에 넣지 않고 훅으로도 제거.
const ALLOWED_ATTR = [
    'href', 'src', 'alt', 'width', 'height', 'style', 'align', 'valign', 'bgcolor',
    'color', 'face', 'size',
]
// inline style 에서 허용할 프로퍼티(레이아웃 붕괴·트래킹 유발 프로퍼티 배제).
const STYLE_PROPS = [
    'color', 'background-color',
    'font-weight', 'font-size', 'font-family', 'font-style',
    'text-align', 'text-decoration', 'line-height', 'vertical-align',
    'width', 'height', 'max-width', 'padding', 'margin', 'border-radius',
]

// style 문자열에서 화이트리스트 프로퍼티만 남기고, url()/mso-*/position/float 는 버린다.
function filterStyle(value) {
    return String(value || '')
        .split(';')
        .map(s => s.trim())
        .filter(Boolean)
        .filter(decl => {
            const idx = decl.indexOf(':')
            if (idx === -1) return false
            const prop = decl.slice(0, idx).trim().toLowerCase()
            if (STYLE_PROPS.indexOf(prop) === -1) return false // 화이트리스트만
            if (/url\s*\(/i.test(decl)) return false // background-image url 차단
            if (/position|float/i.test(prop)) return false
            return true
        })
        .join('; ')
}

// DOMPurify 로 붙여넣기 HTML 을 정제한다. 훅으로 style 프로퍼티 필터 + class/style태그 제거.
function sanitizePastedHtml(DOMPurify, html) {
    if (!DOMPurify || !html) return ''
    const hook = (node, data) => {
        if (data.attrName === 'class') {
            data.keepAttr = false // class 전역 금지
            return
        }
        if (data.attrName === 'style') {
            data.attrValue = filterStyle(data.attrValue)
            if (!data.attrValue) data.keepAttr = false
        }
    }
    DOMPurify.addHook('uponSanitizeAttribute', hook)
    try {
        return DOMPurify.sanitize(html, {
            ALLOWED_TAGS: ALLOWED_TAGS,
            ALLOWED_ATTR: ALLOWED_ATTR,
            // <style> 블록·스크립트는 통째 차단(Gmail 이 <style> 를 지우면 프레임 class 즉사).
            FORBID_TAGS: ['style', 'script', 'link', 'meta'],
            // http/https/mailto 만. javascript: data: 등 차단.
            ALLOWED_URI_REGEXP: /^(?:https?:|mailto:)/i,
            RETURN_TRUSTED_TYPE: false,
        })
    } finally {
        DOMPurify.removeHook('uponSanitizeAttribute')
    }
}

module.exports = {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    STYLE_PROPS,
    filterStyle,
    sanitizePastedHtml,
}
